// extracted by mini-css-extract-plugin
module.exports = {"section_color":"OtherWorksByTheAuthor_section_color__QtIv2","section_first":"OtherWorksByTheAuthor_section_first__4vmyF"};